import { render, staticRenderFns } from "./PartnerSlider.vue?vue&type=template&id=49bb4db3&scoped=true&"
import script from "./PartnerSlider.vue?vue&type=script&lang=js&"
export * from "./PartnerSlider.vue?vue&type=script&lang=js&"
import style0 from "./PartnerSlider.vue?vue&type=style&index=0&id=49bb4db3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bb4db3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49bb4db3')) {
      api.createRecord('49bb4db3', component.options)
    } else {
      api.reload('49bb4db3', component.options)
    }
    module.hot.accept("./PartnerSlider.vue?vue&type=template&id=49bb4db3&scoped=true&", function () {
      api.rerender('49bb4db3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PartnerSlider.vue"
export default component.exports